import { Explain, Key } from '@otp/icons';
import {
  ActionsColumn,
  Breadcrumbs,
  BreadcrumbsItem,
  Callout,
  Delimiter,
  Modal,
} from '@otp/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Maybe, PermissionAssignedBy } from 'src/graphql/generated/graphql';

type AssignedByColumnProps = {
  assignedBy: PermissionAssignedBy[];
};

export const AssignedByColumn = ({ assignedBy }: AssignedByColumnProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'permissions.explain-modal',
  });

  const [isDisplayingExplanation, setIsDisplayingExplanation] = useState(false);

  const breadCrumbsItems = assignedBy.map(
    (permission: Maybe<PermissionAssignedBy> | undefined) => {
      const breadCrumbProps: BreadcrumbsItem[] = [];

      while (permission) {
        breadCrumbProps.push({
          label: `${permission.type}: ${permission.name}`,
        });

        permission = permission.assignedBy?.[0];
      }

      return breadCrumbProps;
    },
  );

  return (
    <>
      <ActionsColumn
        icons={[
          {
            icon: <Explain />,
            onClick: () => setIsDisplayingExplanation(true),
          },
        ]}
      />
      <Modal
        open={isDisplayingExplanation}
        onClose={() => setIsDisplayingExplanation(false)}
        title={t('title')}
      >
        <Callout severity="info" className="mb-6 min-w-medium">
          {t('description')}
        </Callout>
        <div className="flex flex-col gap-4 px-2">
          {breadCrumbsItems.map((items) => (
            <>
              <Breadcrumbs items={items} icon={<Key />} withoutDefaultLink />
              <Delimiter />
            </>
          ))}
        </div>
      </Modal>
    </>
  );
};
